import React from 'react';
import ReactModal from 'react-modal';
// Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)
ReactModal.setAppElement('#react-modal-root');
const modalCustomStyles = {
    overlay: {
        background: 'rgba(18, 33, 63, 0.27)',
        zIndex: 2,
    },
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        padding: '0',
        transform: 'translate(-50%, -50%)',
        border: '1px solid #DEE2E6',
        borderRadious: '8px',
        boxShadow: '0px 20px 20px 0px #00000014',
    },
};
export const BaseModal = ({ children, isOpen, handleClose }) => (React.createElement(ReactModal, { isOpen: isOpen, onRequestClose: handleClose, style: modalCustomStyles }, children));
